/**
 * modal.js - モーダルダイアログの汎用制御（再利用可能）
 *
 * 主な機能：
 * - data-modal-id を持つ要素をクリックで対応する <dialog> を開く
 * - アニメーション付きの開閉
 * - 閉じるボタン（.closeDialog）、背景クリック、Esc キーでの閉じる動作
 *
 * 使い方：
 * - 開くボタン: [data-modal-id="モーダルID"] を付与
 * - ダイアログ: <dialog data-modal-id="モーダルID">
 * - 閉じるボタン: .closeDialog クラスを付与
 */

const ANIMATION_MS = 240; // モーダル開閉アニメーションの所要時間（ミリ秒）
const initializedDialogs = new WeakSet(); // 既にイベントを登録したダイアログを管理（重複登録防止）

/** モーダルダイアログを開き、表示アニメーションを適用する */
const openDialog = (dialog) => {
  if (!dialog.open) {
    dialog.showModal();
  }

  dialog.classList.remove("is-closing");
  requestAnimationFrame(() => {
    dialog.classList.add("is-visible");
  });
};

/** モーダルダイアログをアニメーション付きで閉じる */
const closeDialogWithAnimation = (dialog) => {
  if (!dialog.open || dialog.classList.contains("is-closing")) return;

  dialog.classList.add("is-closing");
  dialog.classList.remove("is-visible");

  // アニメーション完了後にダイアログを実際に閉じる
  window.setTimeout(() => {
    dialog.close();
    dialog.classList.remove("is-closing");
  }, ANIMATION_MS);
};

// ========== モーダルダイアログのイベント設定 ==========
// data-modal-id を持つ各「開くボタン」に対応するダイアログを紐付け、開閉イベントを登録
const showButtons = document.querySelectorAll("[data-modal-id]");

showButtons.forEach((button) => {
  const modalId = button.getAttribute("data-modal-id");
  if (!modalId) return;

  const dialog = document.querySelector(`dialog[data-modal-id="${modalId}"]`);
  if (!dialog) return;

  button.addEventListener("click", (event) => {
    // アンカーリンクの場合はデフォルトの遷移を防止
    if (button.tagName === "A" && button.getAttribute("href")) {
      event.preventDefault();
    }
    openDialog(dialog);
  });

  // 同一ダイアログに対するイベント重複登録を防ぐ
  if (initializedDialogs.has(dialog)) return;
  initializedDialogs.add(dialog);

  // 閉じるボタン用のイベント
  const closeButton = dialog.querySelector(".closeDialog");
  if (closeButton) {
    closeButton.addEventListener("click", () => closeDialogWithAnimation(dialog));
  }

  // ダイアログの背景（backdrop）クリックで閉じる
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) {
      closeDialogWithAnimation(dialog);
    }
  });

  // Esc キー押下で閉じる（cancel イベント）
  dialog.addEventListener("cancel", (event) => {
    event.preventDefault();
    closeDialogWithAnimation(dialog);
  });
});
